<script>
    import { selectedItem } from '../../store/store.js';
    let expandedFaq = null;

    function toggleFaq(index) {
        expandedFaq = expandedFaq === index ? null : index;
    }

    function formatAnswer(items) {
        return items
            .filter(item => item && item !== "Uppgifter saknas")
            .map(item => `<p>${item}</p>`)
            .join('');
    }

    function displayUthyrningPermission(item) {
        if (item === true) {
            return "Tillåtelse krävs för uthyrning.";
        } else if (item === false) {
            return "Tillåtelse krävs ej för uthyrning.";
        } else {
            return null;
        }
    }

    function formatJuridiskPerson(value) {
        if (value === null || value === undefined) return null;
        return value ? "Tillåts" : "Tillåts ej";
    }

    $: faqs = [
        // Medlemskap
        ...($selectedItem?.membership?.application_process && $selectedItem.membership.application_process !== "Uppgifter saknas" ? [{
            question: 'Hur ansöker man om medlemskap?',
            answer: `<p>${$selectedItem.membership.application_process}</p>`
        }] : []),
        ...($selectedItem?.membership?.membership_denial_grounds && $selectedItem.membership.membership_denial_grounds !== "Uppgifter saknas" ? [{
            question: 'Kan medlemskap nekas? På vilka grunder?',
            answer: `<p>${$selectedItem.membership.membership_denial_grounds}</p>`
        }] : []),
        ...($selectedItem?.membership?.termination_of_membership && $selectedItem.membership.termination_of_membership !== "Uppgifter saknas" ? [{
            question: 'Uteslutning och utträde ur föreningen',
            answer: `<p>${$selectedItem.membership.termination_of_membership}</p>`
        }] : []),
        ...(formatJuridiskPerson($selectedItem?.membership?.juridisk_person_is_allowed) ? [{
            question: 'Kan juridisk person äga bostadsrätt?',
            answer: `<p>${formatJuridiskPerson($selectedItem.membership.juridisk_person_is_allowed)}</p>`
        }] : []),

        // Ekonomi och avgifter
        ...(formatAnswer([
            $selectedItem?.financial_obligations?.annual_fee?.payment_schedule,
            $selectedItem?.financial_obligations?.annual_fee?.calculation_method
        ]) ? [{
            question: 'Årsavgift',
            answer: formatAnswer([
                $selectedItem?.financial_obligations?.annual_fee?.payment_schedule,
                $selectedItem?.financial_obligations?.annual_fee?.calculation_method
            ])
        }] : []),
        ...($selectedItem?.financial_obligations?.pledge_fee && $selectedItem.financial_obligations.pledge_fee !== "Uppgifter saknas" ? [{
            question: 'Pantsättning',
            answer: `<p>${$selectedItem.financial_obligations.pledge_fee}</p>`
        }] : []),
        ...($selectedItem?.financial_obligations?.transfer_fee && $selectedItem.financial_obligations.transfer_fee !== "Uppgifter saknas" ? [{
            question: 'Överlåtelseavgift',
            answer: `<p>${$selectedItem.financial_obligations.transfer_fee}</p>`
        }] : []),
        ...(formatAnswer([
            $selectedItem?.financial_obligations?.subletting_fee?.payment_terms,
            $selectedItem?.financial_obligations?.subletting_fee?.max_percentage,
            $selectedItem?.financial_obligations?.subletting_fee?.calculation_basis
        ]) ? [{
            question: 'Uthyrning av lägenhet',
            answer: formatAnswer([
                $selectedItem?.financial_obligations?.subletting_fee?.payment_terms,
                $selectedItem?.financial_obligations?.subletting_fee?.max_percentage,
                $selectedItem?.financial_obligations?.subletting_fee?.calculation_basis
            ])
        }] : []),
        ...($selectedItem?.financial_obligations?.late_payment_interest && $selectedItem.financial_obligations.late_payment_interest !== "Uppgifter saknas" ? [{
            question: 'Dröjsmålsränta',
            answer: `<p>${$selectedItem.financial_obligations.late_payment_interest}</p>`
        }] : []),

        // Upplåtelse och övergång
        ...($selectedItem?.ownership_transfer?.transfer_agreement_requirements && $selectedItem.ownership_transfer.transfer_agreement_requirements !== "Uppgifter saknas" ? [{
            question: 'Krav på överlåtelseavtal',
            answer: `<p>${$selectedItem.ownership_transfer.transfer_agreement_requirements}</p>`
        }] : []),
        ...($selectedItem?.ownership_transfer?.membership_rights_after_transfer && $selectedItem.ownership_transfer.membership_rights_after_transfer !== "Uppgifter saknas" ? [{
            question: 'Medlemsrätt efter överlåtelse',
            answer: `<p>${$selectedItem.ownership_transfer.membership_rights_after_transfer}</p>`
        }] : []),

        // Äganderättens avgång
        ...($selectedItem?.resignation_of_ownership?.process && $selectedItem.resignation_of_ownership.process !== "Uppgifter saknas" ? [{
            question: 'Process för äganderättens avgång',
            answer: `<p>${$selectedItem.resignation_of_ownership.process}</p>`
        }] : []),
        ...($selectedItem?.resignation_of_ownership?.time_restrictions && $selectedItem.resignation_of_ownership.time_restrictions !== "Uppgifter saknas" ? [{
            question: 'Tidsbegränsning för äganderättens avgång',
            answer: `<p>${$selectedItem.resignation_of_ownership.time_restrictions}</p>`
        }] : []),

        // Rättigheter och skylldigheter
        ...($selectedItem?.rights_and_obligations?.access_rights && $selectedItem.rights_and_obligations.access_rights !== "Uppgifter saknas" ? [{
            question: 'Tillträde till lägenheten',
            answer: `<p>${$selectedItem.rights_and_obligations.access_rights}</p>`
        }] : []),
        ...(formatAnswer([
            $selectedItem?.rights_and_obligations?.subletting_rules?.time_limits,
            $selectedItem?.rights_and_obligations?.subletting_rules?.fee_structure,
            $selectedItem?.rights_and_obligations?.subletting_rules?.special_conditions,
            displayUthyrningPermission($selectedItem?.rights_and_obligations?.subletting_rules?.permission_required)
        ]) ? [{
            question: 'Andrahandsuthyrning',
            answer: formatAnswer([
                $selectedItem?.rights_and_obligations?.subletting_rules?.time_limits,
                $selectedItem?.rights_and_obligations?.subletting_rules?.fee_structure,
                $selectedItem?.rights_and_obligations?.subletting_rules?.special_conditions,
                displayUthyrningPermission($selectedItem?.rights_and_obligations?.subletting_rules?.permission_required)
            ])
        }] : []),
        ...($selectedItem?.rights_and_obligations?.insurance_requirements && $selectedItem.rights_and_obligations.insurance_requirements !== "Uppgifter saknas" ? [{
            question: 'Försäkringskrav',
            answer: `<p>${$selectedItem.rights_and_obligations.insurance_requirements}</p>`
        }] : []),
        ...(formatAnswer([
            $selectedItem?.rights_and_obligations?.property_modifications?.restricted_actions,
            $selectedItem?.rights_and_obligations?.property_modifications?.permission_requirements
        ]) ? [{
            question: 'Ändringar i lägenheten',
            answer: formatAnswer([
                $selectedItem?.rights_and_obligations?.property_modifications?.restricted_actions,
                $selectedItem?.rights_and_obligations?.property_modifications?.permission_requirements
            ])
        }] : []),
        ...($selectedItem?.rights_and_obligations?.noise_and_conduct_rules && $selectedItem.rights_and_obligations.noise_and_conduct_rules !== "Uppgifter saknas" ? [{
            question: 'Störningar och ordning',
            answer: `<p>${$selectedItem.rights_and_obligations.noise_and_conduct_rules}</p>`
        }] : []),
        ...(formatAnswer([
            $selectedItem?.rights_and_obligations?.maintenance_responsibilities?.member_responsibilities,
            $selectedItem?.rights_and_obligations?.maintenance_responsibilities?.association_responsibilities
        ]) ? [{
            question: 'Underhållsskylldighet',
            answer: formatAnswer([
                $selectedItem?.rights_and_obligations?.maintenance_responsibilities?.member_responsibilities,
                $selectedItem?.rights_and_obligations?.maintenance_responsibilities?.association_responsibilities
            ])
        }] : []),

        // Förverkande av äganderätten
        ...($selectedItem?.forfeiture_of_ownership?.legal_consequences && $selectedItem.forfeiture_of_ownership.legal_consequences !== "Uppgifter saknas" ? [{
            question: 'Lagliga konsekvenser vid förverkande av äganderätten',
            answer: `<p>${$selectedItem.forfeiture_of_ownership.legal_consequences}</p>`
        }] : []),
        ...($selectedItem?.forfeiture_of_ownership?.grounds_for_forfeiture && $selectedItem.forfeiture_of_ownership.grounds_for_forfeiture !== "Uppgifter saknas" ? [{
            question: 'Grund för förverkande av äganderätten',
            answer: `<p>${$selectedItem.forfeiture_of_ownership.grounds_for_forfeiture}</p>`
        }] : []),

        // Styrning
        ...(formatAnswer([
            $selectedItem?.governance?.board_structure?.number_of_members,
            $selectedItem?.governance?.board_structure?.supplementary_members
        ]) ? [{
            question: 'Styrelsestruktur',
            answer: formatAnswer([
                $selectedItem?.governance?.board_structure?.number_of_members,
                $selectedItem?.governance?.board_structure?.supplementary_members
            ])
        }] : []),
        ...($selectedItem?.governance?.board_authorities && $selectedItem.governance.board_authorities !== "Uppgifter saknas" ? [{
            question: 'Styrelsens ansvar',
            answer: `<p>${$selectedItem.governance.board_authorities}</p>`
        }] : []),
        ...($selectedItem?.governance?.decision_making_process && $selectedItem.governance.decision_making_process !== "Uppgifter saknas" ? [{
            question: 'Beslutsprocess',
            answer: `<p>${$selectedItem.governance.decision_making_process}</p>`
        }] : []),

        // Föreningsstämma
        ...($selectedItem?.general_meeting?.schedule && $selectedItem.general_meeting.schedule !== "Uppgifter saknas" ? [{
            question: 'Mötesschema för föreningsstämma',
            answer: `<p>${$selectedItem.general_meeting.schedule}</p>`
        }] : []),
        ...($selectedItem?.general_meeting?.agenda_items && $selectedItem.general_meeting.agenda_items !== "Uppgifter saknas" ? [{
            question: 'Agendapunkter för föreningsstämma',
            answer: `<p>${$selectedItem.general_meeting.agenda_items}</p>`
        }] : []),
        ...($selectedItem?.general_meeting?.notice_period && $selectedItem.general_meeting.notice_period !== "Uppgifter saknas" ? [{
            question: 'Tidsfrist för föreningsstämma',
            answer: `<p>${$selectedItem.general_meeting.notice_period}</p>`
        }] : []),
        ...(formatAnswer([
            $selectedItem?.general_meeting?.voting_rights?.proxy_voting,
            $selectedItem?.general_meeting?.voting_rights?.voting_process
        ]) ? [{
            question: 'Röstvillkor',
            answer: formatAnswer([
                $selectedItem?.general_meeting?.voting_rights?.proxy_voting,
                $selectedItem?.general_meeting?.voting_rights?.voting_process
            ])
        }] : []),

        // Underhållsplan
        ...($selectedItem?.maintenance_plan?.funding_mechanisms && $selectedItem.maintenance_plan.funding_mechanisms !== "Uppgifter saknas" ? [{
            question: 'Finansiering av underhållsplan',
            answer: `<p>${$selectedItem.maintenance_plan.funding_mechanisms}</p>`
        }] : []),
        ...($selectedItem?.maintenance_plan?.maintenance_schedule && $selectedItem.maintenance_plan.maintenance_schedule !== "Uppgifter saknas" ? [{
            question: 'Tidsplan för underhåll',
            answer: `<p>${$selectedItem.maintenance_plan.maintenance_schedule}</p>`
        }] : []),

        // Vinstfördelning
        ...($selectedItem?.profit_distribution?.distribution_method && $selectedItem.profit_distribution.distribution_method !== "Uppgifter saknas" ? [{
            question: 'Vinstfördelning',
            answer: `<p>${$selectedItem.profit_distribution.distribution_method}</p>`
        }] : []),

        // Upplösning och likvidation
        ...($selectedItem?.dissolution_and_liquidation?.asset_distribution && $selectedItem.dissolution_and_liquidation.asset_distribution !== "Uppgifter saknas" ? [{
            question: 'Upplösning och likvidation',
            answer: `<p>${$selectedItem.dissolution_and_liquidation.asset_distribution}</p>`
        }] : []),

        // Övrigt
        ...($selectedItem?.miscellaneous?.applicable_laws && $selectedItem.miscellaneous.applicable_laws !== "Uppgifter saknas" ? [{
            question: 'Tillämpade lagar',
            answer: `<p>${$selectedItem.miscellaneous.applicable_laws}</p>`
        }] : []),
        ...($selectedItem?.miscellaneous?.historical_building_considerations && $selectedItem.miscellaneous.historical_building_considerations !== "Uppgifter saknas" ? [{
            question: 'Bevarandeavvägningar',
            answer: `<p>${$selectedItem.miscellaneous.historical_building_considerations}</p>`
        }] : [])
    ].filter(faq => faq.answer && faq.answer.trim() !== '');
</script>

{#if faqs.length > 0}
<section class="stadgar-faq-section">
    <h2>Detaljerad information från stadgarna</h2>
    <p class="stadgar-faq-subtitle">Här hittar du all information från föreningens stadgar.</p>

    <div class="stadgar-faq-container">
        {#each faqs as faq, i}
            <div class="stadgar-faq-item">
                <button class="stadgar-faq-toggle" on:click={() => toggleFaq(i)}>
                    <span class="stadgar-faq-title">{faq.question}</span>
                    <span class="stadgar-faq-icon" class:expanded={expandedFaq === i}>+</span>
                </button>
                {#if expandedFaq === i}
                    <div class="stadgar-faq-content">
                        {@html faq.answer}
                    </div>
                {/if}
            </div>
        {/each}
    </div>
</section>
{/if}

<style>
    .stadgar-faq-section {
        padding: 40px 20px;
        max-width: 800px;
        margin: 0 auto;
        width: 100%;
        text-align: center;
    }

    .stadgar-faq-section h2 {
        font-size: 2rem;
        margin-bottom: 20px;
        color: #333;
    }

    .stadgar-faq-subtitle {
        font-size: 1.1rem;
        color: #555;
        margin-bottom: 40px;
        line-height: 1.6;
    }

    .stadgar-faq-container {
        max-width: 600px;
        margin: 0 auto;
    }

    .stadgar-faq-item {
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 0;
    }

    .stadgar-faq-item:last-child {
        border-bottom: none;
    }

    .stadgar-faq-toggle {
        width: 100%;
        background: none;
        border: none;
        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        font-size: 1.1rem;
        font-weight: 500;
        color: #333;
        text-align: left;
        transition: all 0.2s ease;
    }

    .stadgar-faq-toggle:hover {
        color: var(--hover);
    }

    .stadgar-faq-title {
        flex: 1;
    }

    .stadgar-faq-icon {
        font-size: 1.5rem;
        font-weight: 300;
        color: #666;
        transition: transform 0.2s ease;
        width: 20px;
        text-align: center;
    }

    .stadgar-faq-icon.expanded {
        transform: rotate(45deg);
    }

    .stadgar-faq-content {
        padding: 0 0 20px 0;
        text-align: left;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        .stadgar-faq-section {
            padding: 30px 15px;
        }
        .stadgar-faq-section h2 {
            font-size: 1.75rem;
        }
        .stadgar-faq-toggle {
            font-size: 1rem;
            padding: 15px 0;
        }
    }
</style>

